import { Injectable, inject } from '@angular/core';

import { SportsProductUtils } from '@frontend/sports/host-app/sports-product/feature/utils';
import { WINDOW } from '@frontend/vanilla/core';
import { BehaviorSubject, Observable, fromEvent, merge } from 'rxjs';

import { EllapsedTimer } from './ellapsed-timer';

@Injectable({ providedIn: 'root' })
export class OnlineDetectionService {
    private readonly _window = inject(WINDOW);
    private offlineTimer?: EllapsedTimer;
    private online$: BehaviorSubject<{ isOnline: boolean; offlineDuration?: number }>;

    constructor() {
        const productUtils = inject(SportsProductUtils);

        this.online$ = new BehaviorSubject({ isOnline: this._window.navigator.onLine });

        merge(fromEvent(this._window, 'online'), fromEvent(this._window, 'offline'))
            .pipe(productUtils.filterSports())
            .subscribe(() => this.updateOnlineStatus());
    }

    onlineChange(): Observable<{ isOnline: boolean; offlineDuration?: number }> {
        return this.online$.asObservable();
    }

    private updateOnlineStatus = () => {
        const isOnline = this._window.navigator.onLine;

        const offlineDuration = isOnline && this.offlineTimer ? this.offlineTimer.ellapsedMilliseconds : undefined;
        this.offlineTimer = isOnline ? undefined : EllapsedTimer.start();

        this.online$.next({ isOnline, offlineDuration });
    };
}
